import React, { useState } from 'react';
import './VideoEmbed.css';

export type VideoAspectRatio = '16:9' | '9:16';

interface VideoEmbedProps {
  embedUrl: string;
  title: string;
  posterSrc: string;
  aspectRatio?: VideoAspectRatio;
}

const VideoEmbed: React.FC<VideoEmbedProps> = ({
  embedUrl,
  title,
  posterSrc,
  aspectRatio = '16:9',
}) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const aspectClass =
    aspectRatio === '9:16' ? 'video-embed--portrait' : 'video-embed--landscape';

  if (isPlaying) {
    const separator = embedUrl.includes('?') ? '&' : '?';
    return (
      <div className={`video-embed ${aspectClass}`}>
        <iframe
          src={`${embedUrl}${separator}autoplay=1`}
          title={title}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
        />
      </div>
    );
  }

  return (
    <div className={`video-embed ${aspectClass}`}>
      <button
        type="button"
        className="video-embed-facade"
        onClick={() => setIsPlaying(true)}
        aria-label={`Play video: ${title}`}
      >
        <img src={posterSrc} alt="" className="video-embed-poster" />
        <span className="video-embed-play" aria-hidden="true">
          <svg viewBox="0 0 68 48" width="68" height="48" focusable="false">
            <path
              className="video-embed-play-bg"
              d="M66.52,7.74c-0.78-2.93-2.49-5.41-5.42-6.19C55.79,.13,34,0,34,0S12.21,.13,6.9,1.55 C3.97,2.33,2.27,4.81,1.48,7.74C0.06,13.05,0,24,0,24s0.06,10.95,1.48,16.26c0.78,2.93,2.49,5.41,5.42,6.19 C12.21,47.87,34,48,34,48s21.79-0.13,27.1-1.55c2.93-0.78,4.64-3.26,5.42-6.19C67.94,34.95,68,24,68,24S67.94,13.05,66.52,7.74z"
            />
            <path className="video-embed-play-icon" d="M 45,24 27,14 27,34" />
          </svg>
        </span>
      </button>
    </div>
  );
};

export default VideoEmbed;
